import { DocumentNoteHeader } from "../../../AdminLayout_Style";
import { EBlogResponse, IBlogGetPage } from "../../../models/blog";
import BlogService from "../../../services/api/blog.service";
import {
  ActionButton,
  BlogListWrapper,
  BlogTable,
  BlogTd,
  BlogTh,
  StatusBadge,
} from "../../../style/admin/Blog_Style";
import { toast } from "../../../utils/notify";
import BlogCreateModal from "./BlogCreateModal";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmDeleteModalBlogFooter from "./ConfirmDeleteModal";
import BlogFooterService from "../../../services/api/blogfooter.service";
import { envConfig } from "../../../config/env.config";

// const blogs = [
//   {
//     id: 1,
//     title: "Giới thiệu ReactJS",
//     author: "Admin",
//     createdAt: "20/01/2026",
//     status: "active",
//   },
//   {
//     id: 2,
//     title: "Hướng dẫn Styled Components",
//     author: "Admin",
//     createdAt: "18/01/2026",
//     status: "inactive",
//   },
// ];

const BlogFooterList = () => {
  //const [openModal, setOpenModal] = useState(false);
  const [blogs, setBlogs] = useState<EBlogResponse[]>();
  const [blog, setBlog] = useState<EBlogResponse | null>(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  type Language = typeof envConfig.KEY_BASE extends "vn"
    ? "VI" | "EN"
    : "VI" | "EN" | "ID" | "TH";

  const [language, setLanguage] = useState<Language>(
    envConfig.KEY_BASE === "vn" ? "VI" : "EN",
  );

  const getPage = async (page = 1) => {
    const data: IBlogGetPage = {
      CurrentPage: page,
      PageSize: pageSize,
      KeySearch: "",
      Language: language,
    };

    var res = await BlogFooterService.adminGetPage(data);

    if (res.success) {
      setBlogs(res.items);

      if (res.items.length === 0 && page > 1) page = 1;
      setCurrentPage(page);
      setTotalPages(res.totalPages);
    }
  };

  useEffect(() => {
    getPage(currentPage);
  }, [currentPage, language]);

  // const handleOpenModal = (data?: EBlogResponse) => {
  //   data && setBlog(data);
  //   setOpenModal(true);
  // };

  // const handleCloseModal = () => {
  //   setBlog(null);
  //   setOpenModal(false);
  // };

  const handleComfrimDeleteModal = () => {
    getPage(currentPage);
    setOpenDeleteModal(false);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  // const handleSumit = () => {
  //   getPage();
  //   setOpenModal(false);
  // };

  return (
    <>
      <DocumentNoteHeader>
        <div
          style={{
            display: "flex",
            gap: 8,
            marginBottom: 16,
            flexWrap: "wrap",
          }}>
          {envConfig.KEY_BASE === "vn" ? (
            <>
              <button
                onClick={() => setLanguage("VI")}
                style={{
                  backgroundColor: "#2563eb",
                  color: "#fff",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: 8,
                  cursor: "pointer",
                  opacity: language === "VI" ? 1 : 0.6,
                  fontWeight: 600,
                }}>
                🇻🇳 Tiếng Việt
              </button>

              <button
                onClick={() => setLanguage("EN")}
                style={{
                  backgroundColor: "#2563eb",
                  color: "#fff",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: 8,
                  cursor: "pointer",
                  opacity: language === "EN" ? 1 : 0.6,
                  fontWeight: 600,
                }}>
                🇬🇧 English
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => setLanguage("EN")}
                style={{
                  backgroundColor: "#2563eb",
                  color: "#fff",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: 8,
                  cursor: "pointer",
                  opacity: language === "EN" ? 1 : 0.6,
                  fontWeight: 600,
                }}>
                🇬🇧 English
              </button>

              <button
                onClick={() => setLanguage("ID")}
                style={{
                  backgroundColor: "#2563eb",
                  color: "#fff",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: 8,
                  cursor: "pointer",
                  opacity: language === "ID" ? 1 : 0.6,
                  fontWeight: 600,
                }}>
                🇮🇩 Indonesia
              </button>

              <button
                onClick={() => setLanguage("TH")}
                style={{
                  backgroundColor: "#2563eb",
                  color: "#fff",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: 8,
                  cursor: "pointer",
                  opacity: language === "TH" ? 1 : 0.6,
                  fontWeight: 600,
                }}>
                🇹🇭 Thai
              </button>
            </>
          )}
        </div>
        <h3>Danh sách Support</h3>
        <button
          style={{
            background: "linear-gradient(135deg, #4f46e5, #6366f1)",
            color: "white",
            padding: "10px 18px",
            border: "none",
            borderRadius: "10px",
            fontSize: "14px",
            fontWeight: 500,
            cursor: "pointer",
            transition: "all 0.25s ease",
            boxShadow: "0 4px 10px rgba(79, 70, 229, 0.3)",
          }}
          onClick={() => navigate("/admin/support/detail")}>
          + Thêm Support
        </button>
      </DocumentNoteHeader>

      <BlogListWrapper>
        <BlogTable>
          <thead>
            <tr>
              <BlogTh>#</BlogTh>
              <BlogTh>Tiêu đề</BlogTh>
              <BlogTh>Tác giả</BlogTh>
              <BlogTh>Ngày tạo</BlogTh>
              <BlogTh>Trạng thái</BlogTh>
              <BlogTh>Thao tác</BlogTh>
            </tr>
          </thead>
          <tbody>
            {blogs &&
              blogs.map((blog, index) => (
                <tr key={blog.id}>
                  <BlogTd>{index + 1}</BlogTd>
                  <BlogTd>{blog.title}</BlogTd>
                  <BlogTd>Admin</BlogTd>
                  <BlogTd>{blog.dateTime.toString()}</BlogTd>
                  <BlogTd>
                    <StatusBadge status={blog.status}>
                      {blog.status === true ? "Hiển thị" : "Ẩn"}
                    </StatusBadge>
                  </BlogTd>
                  <BlogTd>
                    <ActionButton
                      onClick={() =>
                        navigate(`/admin/support/detail/${blog.id}`)
                      }>
                      Sửa
                    </ActionButton>
                    <ActionButton
                      className="delete"
                      onClick={() => {
                        blog.id && setDeleteId(blog.id);
                        setOpenDeleteModal(true);
                      }}>
                      Xóa
                    </ActionButton>
                  </BlogTd>
                </tr>
              ))}
          </tbody>
        </BlogTable>

        <div style={{ marginTop: 16 }}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}>
            Prev
          </button>

          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentPage(i + 1)}
              style={{
                fontWeight: currentPage === i + 1 ? "bold" : "normal",
                margin: "0 4px",
              }}>
              {i + 1}
            </button>
          ))}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}>
            Next
          </button>
        </div>
      </BlogListWrapper>

      <ConfirmDeleteModalBlogFooter
        open={openDeleteModal}
        blogId={deleteId}
        onClose={handleCloseDeleteModal}
        onConfirm={handleComfrimDeleteModal}
      />

      {/* <BlogCreateModal
        blog={blog}
        open={openModal}
        onClose={handleCloseModal}
        onHandleSubmit={handleSumit}
      /> */}
    </>
  );
};

export default BlogFooterList;
